import { Box, Button, Modal, Theme, createStyles, makeStyles } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => createStyles({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    fontFamily: 'Roboto',
  },
  modalContent: {
    background: 'linear-gradient(180deg, #001A3D 0%, #004093 100%)',
    borderRadius: 4,
    minHeight: 200,
    width: 860,
    height: 483,
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'space-between',
    alignItems: 'center',
    overflow: 'hidden',
  },
}
));

const LockIcon = () => {
  return (
    <>
      <Box display="flex" justifyContent="center" alignItems="center" fontSize="16px" marginLeft="16px" color="#8F9296" onClick={() => console.log('locked')}>
        <div>MAX</div>
        <LockSVG />
      </Box>
    </>
  )
}

export const UpgradeModal = (props: { open: boolean, onClose: () => void }) => {
  const { open = false, onClose } = props;
  const classes = useStyles();
  return (
    <>
      <Modal open={open} className={classes.modal} disableAutoFocus onClose={(event: object, reason: string) => {
        if (reason?.toLowerCase() === 'backdropclick') {
          onClose()
        }
      }}>
        <div className={classes.modalContent}>
          <Box width="93px" height="30px" padding={4}>
            <img src={`${process.env.PUBLIC_URL}/images/stokastic-tools-logo.png`} alt="Stokastic" style={{ width: '100%', height: '100%'}} />
          </Box>
          <Box fontSize="44px" fontWeight="900" fontFamily="Inter">UPGRADE TO SIMS MAX</Box>
          <Box margin="8px 0" fontSize="20px" fontWeight="500" fontFamily="Inter">And you can:</Box>
          <Box fontSize="30px" fontWeight="700" fontFamily="Inter">
            <ul>
              <li>Sim up to 10,000 lineups</li>
              <li>Favorite unlimited lineups</li>
              <li>Generate up to 10,000 lineups</li>
              <li>View all Post-Contest Simulations</li>
            </ul>
          </Box>
          <Button href='https://www.stokastic.com/account/?action=subscriptions' variant='contained' style={{ color: 'white', fontSize: '34px', fontWeight: 700, fontFamily: 'Inter', padding: '6px 55px', borderRadius: '10px', backgroundColor: '#015ACE', boxShadow: '0px 10px 20px 0px rgba(0, 0, 0, 0.25)' }}>UPGRADE TO MAX</Button>
        </div>
      </Modal>
      </>
  )
}

const LockSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20">
    <path
      fill="currentColor"
      d="M220-80q-24.75 0-42.375-17.625T160-140v-434q0-24.75 17.625-42.375T220-634h70v-96q0-78.85 55.606-134.425Q401.212-920 480.106-920T614.5-864.425Q670-808.85 670-730v96h70q24.75 0 42.375 17.625T800-574v434q0 24.75-17.625 42.375T740-80H220Zm260.168-200Q512-280 534.5-302.031T557-355q0-30-22.668-54.5t-54.5-24.5Q448-434 425.5-409.5t-22.5 55q0 30.5 22.668 52.5t54.5 22ZM350-634h260v-96q0-54.167-37.882-92.083-37.883-37.917-92-37.917Q426-860 388-822.083 350-784.167 350-730v96Z"
    />
  </svg>
)

export default LockIcon